import {Tile, TileProps, TileSubjectProps} from "../components/Tile.tsx";
import {Bundle, BundleStub} from "../rpc/webrpc-client.gen.ts";
import {PropsWithChildren} from "react";
import {BundleCapsule} from "./capsule.tsx";
import {Stack} from "@mui/joy";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHourglassStart} from "@fortawesome/pro-regular-svg-icons";
import {VenueCapsule} from "../venue/capsule.tsx";
import {TruckCapsule} from "../truck/capsule.tsx";
import {RouterJoyLink} from "../link.tsx";

// export interface BundleTileDetails {
//     sendCompany?: boolean;
//     transportCompany?: boolean;
//     receiveCompany?: boolean;
//     pickupPlace?: boolean;
//     dropoffVenue?: boolean;
//     lastTruck?: boolean;
//     status?: boolean;
//     photoRequired?: boolean;
// }
//

export function useBundlePickupPlaceCapsule({bundle}: { bundle?: Bundle }) {
    return bundle
        ? <Stack direction="row" spacing={0.5} sx={{alignItems: "center"}}>
            <FontAwesomeIcon icon={faHourglassStart}/>
            {bundle.origin.venue
                ? <VenueCapsule venue={bundle.origin.venue}/>
                : <TruckCapsule truck={bundle.origin.truck}/>}
        </Stack>
        : null;
}

export interface BundleTileProps extends Omit<TileProps, "Subject"> {
    bundleStub: BundleStub;
    photoRequired?: boolean;
    linkify?: boolean;
    // details?: BundleTileDetails;
    // actions?: ReactNode;
}

export function BundleTile({
                               bundleStub,
                               photoRequired,
                               linkify,
                               children,
                               color,
                               ...rest
                           }: PropsWithChildren<BundleTileProps>) {
    const subject = (props: TileSubjectProps) => {
        const capsule = <BundleCapsule bundle={bundleStub} photoRequired={photoRequired} {...props}/>
        const rv = linkify
            ? <RouterJoyLink color={color} to="/bundle/$id/cargo" params={{id: bundleStub.id}}>
                {capsule}
            </RouterJoyLink>
            : capsule;
        return rv;
    };
    return <Tile color={color} {...rest} Subject={subject}>
        {children}
    </Tile>
}

//
// export function BundleTile(props: BundleTileProps) {
//     const {
//         bundleStub: inBundleStub,
//         linkify,
//         details,
//         variant: inVariant,
//         ...rest
//     } = props;
//     const {id: bundleId} = inBundleStub;
//     const mama = useMothership();
//     const {data: bundleData, isSuccess: isBundleSuccess}
//         = useQuery(peekBundleByIdTqo(mama, {bundleId}));
//     const enabled = isBundleSuccess;
//     const bundle = bundleData?.bundle;
//     const icon = iconForEntityType("bundle");
//     const {data: status, isSuccess: isStatusSuccess}
//         = useBundleStatus({bundleId});
//     const {data: lastTransferData}
//         = useRefreshableQuery(watchLastTransferForBundleTqo(mama, {bundleId}));
//     const lastTransfer = lastTransferData?.transfer;
//     const {data: jobData, isSuccess: isJobSuccess}
//         = useQuery({
//         ...peekJobByIdTqo(mama, {jobId: bundle?.job.id ?? TQDEADBEEF}),
//         enabled,
//     });
//     const job = jobData?.job;
//     const theme = useTheme();
//     const variant = inVariant ?? "plain";
//     const underVariant = variant === "outlined" ? "plain" : variant;
//     const {fgColor, bgColor} = figureColors({
//         theme, color: props.color, variant: props.variant, invertedColors: props.invertedColors
//     });
//
//     if (!isBundleSuccess || !isJobSuccess || !bundle || !isStatusSuccess) {
//         return null;
//     }
//
//     const capsuleFood: CapsulableEntity = {...bundle, icon};
//     return <Tile variant={variant} color={props.color} Subject={() =>
//         <>{linkify
//             ? <RouterJoyLink to={bundleRoute.to} params={{id: bundle.id}} underline="hover">
//                 <EntityCapsule entity={capsuleFood}/>
//             </RouterJoyLink>
//             : <EntityCapsule entity={capsuleFood}/>}
//             {details?.photoRequired
//                 ? <Box sx={{pl: 0.8, color: theme.palette.primary[700]}}><FontAwesomeIcon icon={faCameraRetro}/></Box>
//                 : null}
//         </>}>
//         {job && details?.sendCompany
//             ? <CompanyCapsule company={job.sendCompany} sx={lowSx}/>
//             : null}
//         {details?.pickupPlace ?? details?.dropoffVenue
//             ? <Stack direction="row" spacing={1.8} sx={{alignItems: "center"}}>
//                 {details.pickupPlace
//                     ? <> {bundle.origin.venue
//                         ? <VenueCapsule venue={bundle.origin.venue} sx={lowSx}/>
//                         : <TruckCapsule truck={bundle.origin.truck}  sx={lowSx} linkify={linkify}/>}
//                         <FontAwesomeIcon icon={faArrowRight} color={fgColor}/>
//                     </>
//                     : null}
//             </Stack>
//             : null}
//         {bundle.destination && details?.dropoffVenue
//             ? <Stack direction="row" spacing={1.8} sx={{alignItems: "center"}}>
//                 <FontAwesomeIcon icon={faArrowRight} color={fgColor}/>
//                 <VenueCapsule venue={bundle.destination} variant={underVariant}
//                               {...rest} sx={lowSx}/>
//             </Stack>
//             : null}
//         {details?.lastTruck && lastTransfer?.truck
//             ? <TruckCapsule truck={lastTransfer.truck} {...rest} sx={lowSx}/>
//             : null}
//         {details?.status
//             ? <Box sx={{fontSize: "lg", mt: 1}}>{status.label}</Box>
//             : null}
//     </Tile>;
// }
//

// export function BundleTile(props: BundleTileProps) {
//     const {
//         bundleId,
//         linkify,
//         details,
//         color: inColor,
//         variant: inVariant,
//         actions,
//         ...rest
//     } = props;
//     const mama = useMothership();
//     const {data: bundleData} = useQuery(peekBundleByIdTqo(mama, {bundleId}));
//     const bundle = bundleData?.bundle;
//     const color = inColor ?? "primary";
//     const variant = inVariant ?? "outlined";
//     const theme = useTheme();
//     // eslint-disable-next-line @typescript-eslint/no-misused-spread
//     const sx = {...inSx, ...TILE_SX, ...tileVariantSpecificSx({theme, color, variant})};
//     const underVariant = variant === "outlined" ? "plain" : variant;
//     // const lowerState: Omit<BundleTileProps, "bundleId"> =
//     //     {bundle, color, variant: underVariant, ...rest};
//     // const {data: bundleStatus, isSuccess: isBundleStatusSuccess}
//     //     = useBundleStatus({
//     //     bundleId,
//     //     enabled: bundleId !== TQDEADBEEF,
//     // });
//
//     if (!bundle) {
//         return null;
//     }
//
//     return <Tile color={color} variant={variant}
//                  Subject={() =>
//                      <ActiveBundleCapsule bundle={bundle} color={color} variant={underVariant}
//                                           details={details} linkify={linkify}
//                                           invertedColors={props.invertedColors}/>}>
//     </Tile>
//
//     return <Card color={color} variant={variant} sx={sx} {...rest}>
//         <CardContent sx={TILE_CONTENT_SX}>
//             <Stack direction="column" spacing={1.6}>
//                 <ActiveBundleCapsule bundle={bundle} color={color} variant={underVariant}
//                                      details={details} linkify={linkify}
//                                      invertedColors={props.invertedColors}/>
//             </Stack>
//         </CardContent>
//         {actions
//             ? <CardActions>{actions.map(
//                 ({key, elem: {children, ...props}}) =>
//                     <ActionButton key={key} sx={TILE_ACTION_BUTTON_SX} {...props}>
//                         {children}
//                     </ActionButton>)}
//             </CardActions>
//             : null}
//     </Card>
// }

